<template>
  <v-dialog v-model="visible"
            persistent
            :max-width="'50%'">
    <v-card v-if="itemDetail">
      <v-card-title>{{title}}</v-card-title>
      <v-card-text>
        <v-layout v-for="col in getDialogKeys" :key="col.value">
          <v-flex>
            <v-textarea v-if="col.value === 'preview'" :label="col.text"
                        v-model="itemDetail[col.value]"/>
            <v-switch v-else-if="col.value === 'status'"
                v-model="itemDetail[col.value]"
                :label="col.text"
            ></v-switch>
            <quill-editor v-else-if="col.value === 'content'"
                          class="mb-2 mt-2"
                          ref="myQuillEditor"
                          v-model="itemDetail[col.value]"
                          :options="editorOption"
                          @blur="onEditorBlur($event)"
                          @focus="onEditorFocus($event)"
                          @ready="onEditorReady($event)"
            />
            <v-text-field v-else v-model="itemDetail[col.value]"
                          :label="col.text"
                          :color="Theme.GREEN"></v-text-field>
            <img style="width: 25%;" v-if="col.isImage" :src="itemDetail[col.value]" />
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-btn v-if="showCancel" :color="Theme.PINK" dark @click="cancelEvent">取消</v-btn>
        <v-spacer></v-spacer>
        <v-btn dark :color="Theme.GREEN" :loading="saveLoading" @click="confirmEvent">確定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import common from "@/mixins/common";
import {mapActions} from 'vuex';

export default {
  name: "news_detail",
  mixins: [common],
  props: {
    title:String,
    itemDetail: Object,
    visible: Boolean,
    showCancel: Boolean,
  },
  data() {
    return {
      saveLoading: false,
      editorOption: {
        placeholder:'詳細介紹'
      },
    };
  },
  created() {
  },
  mounted() {
    console.log('this is current quill instance object', this.editor);
  },
  computed: {
    editor() {
      if (this.$refs.myQuillEditor) {
        return this.$refs.myQuillEditor.quill
      }
      return null;
    },
    getDialogKeys() {
      return [
        {value: 'title', text: '標題'},
        {value: 'preview', text: '簡介'},
        {value: 'status', text: '顯示'},
        {value: 'content', text: '詳細說明'},
        {value: 'imageUrl', text: '圖片網址', isImage: true},
      ];
    },
  },
  methods: {
    ...mapActions(['saveNewsInfo','getNewsInfo']),
    async loadData(){
      try {
        if (!this.itemDetail.id) return;

        const res = await this.getNewsInfo({id: this.itemDetail.id });
        const result = res.data;
        console.log(`getNewsInfo == ${JSON.stringify(result)}`);
        if (result.statusCode === 0){
          this.itemDetail.content = result.data[0].content;
          this.$forceUpdate();
        }
      } catch (e) {
        console.log(`getNewsInfo error `, e);
      }
    },
    onEditorBlur(quill) {
      console.log('editor blur!', quill)
    },
    onEditorFocus(quill) {
      console.log('editor focus!', quill)
    },
    onEditorReady(quill) {
      console.log('editor ready!', quill);
      quill.container.style.height = '500px';
      this.loadData();
    },
    onEditorChange({ quill, html, text }) {
      console.log('editor change!', quill, html, text)
      this.content = html
    },
    cancelEvent() {
      this.$emit('cancelEvent');
    },
    async confirmEvent() {
     try {
       this.saveLoading = true;

       console.log(`save ${JSON.stringify(this.itemDetail)}`);
       const res = await this.saveNewsInfo(this.itemDetail);
       const result = res.data;
       if (result.statusCode === 0) {
         this.$emit('confirmEvent', this.itemDetail);
       } else {
         this.showMessageDialog('錯誤', result.message ? result.message : '儲存失敗');
       }
       this.saveLoading = false;
     }catch (e) {
       this.showMessageDialog('錯誤',  '儲存失敗');
     } finally {
       this.saveLoading = false;
     }

    },
    showMessageDialog(title, content) {
      console.log(`showAlert ${title} ${content}`);
      this.showAlert({
        title: title,
        content: content,
        confirmEvent: async () => {
          this.hideAlert();
        }
      });
    },
  }
}
</script>

<style scoped>
.ql-size-large {
  font-size: 18px;
}
</style>
